/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Tournament } from './Tournament';
import {
    TournamentFromJSON,
    TournamentFromJSONTyped,
    TournamentToJSON,
    TournamentToJSONTyped,
} from './Tournament';

/**
 * Result of cancelling a tournament
 * @export
 * @interface TournamentCancellationResponse
 */
export interface TournamentCancellationResponse {
    /**
     * 
     * @type {Tournament}
     * @memberof TournamentCancellationResponse
     */
    tournament: Tournament;
    /**
     * Number of refunds issued
     * @type {number}
     * @memberof TournamentCancellationResponse
     */
    refundsIssued: number;
    /**
     * Total amount refunded in cents
     * @type {number}
     * @memberof TournamentCancellationResponse
     */
    totalRefunded: number;
}

/**
 * Check if a given object implements the TournamentCancellationResponse interface.
 */
export function instanceOfTournamentCancellationResponse(value: object): value is TournamentCancellationResponse {
    if (!('tournament' in value) || value['tournament'] === undefined) return false;
    if (!('refundsIssued' in value) || value['refundsIssued'] === undefined) return false;
    if (!('totalRefunded' in value) || value['totalRefunded'] === undefined) return false;
    return true;
}

export function TournamentCancellationResponseFromJSON(json: any): TournamentCancellationResponse {
    return TournamentCancellationResponseFromJSONTyped(json, false);
}

export function TournamentCancellationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentCancellationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tournament': TournamentFromJSON(json['tournament']),
        'refundsIssued': json['refundsIssued'],
        'totalRefunded': json['totalRefunded'],
    };
}

export function TournamentCancellationResponseToJSON(json: any): TournamentCancellationResponse {
    return TournamentCancellationResponseToJSONTyped(json, false);
}

export function TournamentCancellationResponseToJSONTyped(value?: TournamentCancellationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tournament': TournamentToJSON(value['tournament']),
        'refundsIssued': value['refundsIssued'],
        'totalRefunded': value['totalRefunded'],
    };
}

